<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="_1-CN ParaOverride-1" id="_idParaDest-5"><span class="leading-139-5 CharOverride-10">F</span><span class="CharOverride-10">or Claire.</span></p>
<p class="DED_Dedication_text">And in memory of Banaz Mahmod <br/>and Rahmat Sulemani.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBookVR02454.vue?ff5778ec